module.exports = __webpack_public_path__ + "img/exhibit-interactive-thumbnail.55044a2e.jpg";